import * as actionTypes from "../actions/actionTypes";

import {
  getAllPollList,
  updatePoll,
  pollPageIncreament,
  clearAllPoll,
  createPoll,
  setPollLoader,
  deletePoll,
} from "../utility/pollListFunctions";

const initialState = {
  pollQuestion: [],
  total: "",
  isLoading: true,
  page: 1,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_POLL_LIST:
      return getAllPollList(state, action.timelinePollList, action.total);

    case actionTypes.UPDATE_POLL:
      return updatePoll(state, action.poll);

    case actionTypes.SET_POLL_LOADER:
      return setPollLoader(state, action.loaderValue);

    case actionTypes.CREATE_POLL:
      return createPoll(state, action.poll);

    case actionTypes.POLL_PAGE_INCREAMENT:
      return pollPageIncreament(state);

    case actionTypes.DELETE_POLL:
      return deletePoll(state, action.pollId);

    case actionTypes.CLEAR_ALL_POLL:
      return clearAllPoll(state);

    default:
      return state;
  }
};

export default reducer;
